import type { SearchResponse } from '@/scopes/search/search/infrastructure/api/types';
import type { QueryClient } from '@tanstack/react-query';
import { searchQueryClient as defaultSearchQueryClient } from '@/scopes/search/search/infrastructure/query-client/searchQueryClient';

export interface SearchQueryRepository {
  getActiveQuery: () => SearchResponse | null;
}

export const createSearchQueryRepository = (
  dependencies: Partial<{ queryClient: QueryClient }> = {}
): SearchQueryRepository => {
  const { queryClient = defaultSearchQueryClient } = dependencies as { queryClient: QueryClient };

  function getActiveQuery() {
    const [[_, data] = [null, null]] = queryClient.getQueriesData({
      queryKey: ['search-results'],
      type: 'active',
    });

    return data as SearchResponse;
  }

  return { getActiveQuery };
};
